import { ToLayoutTypeMetadata } from "../layout-type-metadata.enum"
import { MetadataFactory } from "../metadata.factory"
import { ArrayJsonSchemaBase } from "../schema/array-json-schema.model"
import { ObjectJsonSchema } from "../schema/object-json-schema.model"
import { ExtendedLayoutMetadataBase } from "./extends-layout.metadata.model"
import { LayoutMetadata, LayoutMetadataBase } from "./layout-metadata.model"
import { RowLayoutMetadata } from "./row-layout.metadata.model"


export class RepeatLayoutMetadataBase extends ExtendedLayoutMetadataBase {

    constructor(type: string) {
        super(type)

        this.name = "Repeat Name " + this.id
        this.addLabel = "Afegir"
        this.description = "Descripció del repetible"
        this.fieldName = "fieldName" + this.id
    }

    schema(schema: ObjectJsonSchema) {
        let schemaCurrent: ArrayJsonSchemaBase = new ArrayJsonSchemaBase(null)
        schema.properties[this.fieldName] = schemaCurrent
        schema.required.push(this.fieldName)
        this.items.forEach(i => {
            let row: RowLayoutMetadata = <RowLayoutMetadata> i
            row.schema(schemaCurrent.items)
        })
    }

    from(layout: LayoutMetadata): void {
        Object.assign(this, layout)
        for (let i = 0; i < this.items.length; i++) {
            const element = this.items[i]
            let type = ToLayoutTypeMetadata(element.type)
            if (type == null) continue

            let item = MetadataFactory.createLayoutFromType(type)
            item.from(element)
            this.items[i] = item
        }
    }
    
}

export interface RepeatLayoutMetadata extends RepeatLayoutMetadataBase { }